import { api_get } from "api/utils";

const CreditLogAPI = {
    list: _list,
};



async function _list(cursor: string) {
    let url = '/credit/log?';
    if (cursor) { url += 'cursor=' + cursor; }
    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}

export default CreditLogAPI;
